import * as Features from './namespaces';

import {
  registerAllActions,
  getAllRegisteredActionTypes,
} from './channels/allActions';

Object.values(Features).forEach(value => {
  registerAllActions(value);
});

export { getAllRegisteredActionTypes };
